<template>
  <div class="content">
    <el-row :gutter="20">
      <el-col :span="5" :xs="24">
        <div class="head-container">
          <el-input
            v-model="agentName"
            placeholder="请输入公司名称"
            clearable
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px"
          />
        </div>
        <div class="head-container">
          <el-tree
            class="agent-tree"
            :data="agentList"
            :props="agentProps"
            node-key="userId"
            :expand-on-click-node="true"
            :filter-node-method="agentFilterNode"
             ref="tree"
            :default-expand-all="expandNode"
            :highlight-current="true"
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <el-col :span="19" :xs="24">
        <el-form :model="queryParams" ref="queryParams" :inline="true">
            <el-form-item prop="productName">
              <el-input v-model="queryParams.productName" placeholder="套餐名称"  clearable></el-input>
            </el-form-item>
            <el-form-item prop="types">
              <el-select v-model="queryParams.types" filterable multiple clearable placeholder="类型">
                <el-option v-for="item in types" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="free">
              <el-select v-model="queryParams.free" filterable  clearable placeholder="赠送套餐">
                <el-option v-for="item in status" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="level">
              <el-select v-model="queryParams.level" filterable  clearable placeholder="代理商层级">
                <el-option v-for="item in levels" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
              <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="handleCreate" >批量设置赠送套餐</el-button>
            </el-form-item>
        </el-form>
        <div class="table">
          <el-table :data="tableData" border id="out-table">
            <el-table-column prop="company" label="公司名称" align="center" min-width="200">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>层级: {{ scope.row.companyNameLevel }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag size="medium">[{{scope.row.username}}]{{ scope.row.company }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="level" label="公司层级" align="center">
                <template slot-scope="scope">
                  {{scope.row.level}}级
                </template>
              </el-table-column>
            <el-table-column prop="productName" label="套餐名称" align="center"></el-table-column>
            <el-table-column prop="types" label="赠送类型" align="center" min-width="140">
              <template slot-scope="scope">
                <el-tag v-for="(item,index) in scope.row.types" :key="index" style="margin: 3px;">{{item}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status =='1'" type="success">启用</el-tag>
                <el-tag v-if="scope.row.status =='0'" type="warning">未启用</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="handleEdit(scope.row)" >编辑</el-button>
                <el-button v-if="!!scope.row.productId" size="mini" type="danger" plain icon="el-icon-delete" @click="deleteProductFree(scope.row)" >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            @size-change="handleSizeChange"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!--新增或者修赠送套餐  -->
    <el-dialog :title="title" :visible.sync="open" @close="cancel" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="公司选择" >
              <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText">
              </el-input>
              <el-checkbox v-model="agentNodeAll" @change="handleCheckedTreeNodeAll($event, 'agent')">全选/全不选</el-checkbox>
              <div class="down-tree">
                  <el-tree
                    class="tree-border"
                    :data="agentList"
                    show-checkbox
                    ref="agent"
                    node-key="userId"
                    :check-strictly="!form.userCheckStrictly"
                    empty-text="加载中，请稍候"
                    :props="defaultProps"
                    :filter-node-method="filterNode"
                  ></el-tree>
              </div>
          </el-form-item>
          <el-form-item  label="赠送套餐" prop="productId" >
            <el-select v-model="form.productId"  placeholder="请选择类赠送套餐">
            <el-option
                  v-for="dict in productFree"
                  :key="dict.id"
                  :label="dict.productName"
                  :value="dict.id"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="赠送方式" prop="types" >
            <el-select v-model="form.types" multiple  placeholder="请选择赠送方式">
            <el-option
                  v-for="dict in types"
                  :key="dict.key"
                  :label="dict.value"
                  :value="dict.key"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="状态" >
            <el-radio-group v-model="form.status">
              <el-radio
                v-for="dict in freeStatus"
                :key="dict.key"
                :label="dict.key"
              >{{dict.value}}</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!--修赠送套餐  -->
    <el-dialog :title="editTitle" :visible.sync="editOpen" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="110px">
          <el-form-item  label="赠送套餐" prop="productId">
            <el-select v-model="editForm.productId"  placeholder="请选择赠送套餐">
            <el-option
                  v-for="dict in productFree"
                  :key="dict.id"
                  :label="dict.productName"
                  :value="dict.id"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="赠送方式" prop="types" >
            <el-select v-model="editForm.types" multiple  placeholder="请选择赠送方式">
            <el-option
                  v-for="dict in types"
                  :key="dict.key"
                  :label="dict.value"
                  :value="dict.key"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="状态" >
            <el-radio-group v-model="editForm.status">
              <el-radio
                v-for="dict in freeStatus"
                :key="dict.key"
                :label="dict.key"
              >{{dict.value}}</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editSubmit">确 定</el-button>
        <el-button @click="cancelEdit">取 消</el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import { agentTreeList,productFreePage,productFree,saveOrUpdateProductFreeBatch ,updateProductFree,removeProductFree} from "@/api/api.js";
export default {
  name: "productFree",
  data() {
    return {
      agentName:'',
      agentProps:{
        children: "children",
        label: "label"
      },
      expandNode:false,
      // 查询条件
      agentList:[],
      status:[
        {key:"1",value:"已设置"},
        {key:"0",value:"未设置"}
      ],
      levels:[
        {key:"1",value:"一级"},
        {key:"2",value:"二级"},
        {key:"3",value:"三级"},
        {key:"4",value:"四级"},
        {key:"5",value:"五级"},
        {key:"6",value:"六级"},
      ],
      queryParams: {
        userId:undefined,
        productName:undefined,
        types:[],
        free:undefined,
        level:undefined

      },
      types:[
        {key:"1",value:"激活赠送"},
        {key:"2",value:"测试套餐用完赠送"},
        {key:"3",value:"公众号领取"}
      ],
      //状态
      freeStatus:[
        {key:'1',value:'启用'},
        {key:'0',value:'停用'}
      ],
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
      title:"",
      // 是否显示弹出层
      open: false,
      filterText:'',
      // 表单参数
      form: {
        productId:undefined,
        types:undefined,
        userCheckStrictly:true,
        userIds: [],
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      productFree:[],
      agentNodeAll: false,
      rules: {
        productId: [
          { required: true, message: "赠送套餐不能为空", trigger: "blur" },
        ],
        types: [
          { required: true, message: "赠送方式不能为空", trigger: "blur" }
        ]
      },
      editTitle:"修改赠送套餐",
      editOpen:false,
      editForm:{
        productId:undefined,
        types:undefined,
      },
      editRules: {
        productId: [
          { required: true, message: "赠送套餐不能为空", trigger: "blur" },
        ],
        types: [
          { required: true, message: "赠送方式不能为空", trigger: "blur" }
        ]
      },

    };
  },
  watch: {
      agentName(val) {
        this.$refs.tree.filter(val);
      },
      filterText(val) {
        this.$refs.agent.filter(val);
      }
    },
  computed: {},
  methods: {
    // 搜索
    search() {
      this.page = 1,
      this.tabeInit();
    },
    //代理商层级
    agentTree(){
      agentTreeList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    // 获取列表
    tabeInit() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productFreePage(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.tabeInit();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.tabeInit();
    },
    agentFilterNode(value, data, node){
      if (!value) return true
      let if_one = data.label.indexOf(value) !== -1
      let if_two = node.parent && node.parent.data && node.parent.data.label && (node.parent.data.label.indexOf(value) !== -1)
      let if_three = node.parent && node.parent.parent && node.parent.parent.data && node.parent.parent.data.label && (node.parent.parent.data.label.indexOf(value) !== -1)
      let result_one = false
      let result_two = false
      let result_three = false
      if(node.level === 1) {
        result_one = if_one
      }else if(node.level === 2) {
        result_two = if_one || if_two
      }else if(node.level === 3) {
        result_three = if_one || if_two || if_three
      }
      return result_one || result_two || result_three
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.userId = data.userId;
      this.tabeInit();
    },
    //表单重置
    reset(){
      if (this.$refs.agent != undefined) {
        this.$refs.agent.setCheckedKeys([]);
      }
      this.form = {
        productId: undefined,
        types: undefined,
        userIds:[],
        status: '1',
        agentCheckStrictly: true,
      };
      this.resetQuery("form");
    },
    productFreeList(){
        productFree().then(res=>{
          if(res.data.code == 200){
              this.productFree = res.data.data;
          }
        })
    },
    // 添加
    handleCreate() {
      this.productFreeList();
      this.reset();
      this.title = "代理商配置赠送套餐";
      this.open = true;
    },
    // 编辑
    handleEdit(row) {
      this.productFreeList();
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editForm.types = !!this.editForm.type?this.editForm.type.split(","):[];
      this.editOpen = true;
    },
    //移除
    deleteProductFree(row){
      this.$confirm('是否确认将【'+row.company+'】的赠送套餐移除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            removeProductFree({id:row.id}).then(res=>{
                if(res.data.code==200){
                  this.$message({
                            type: 'success',
                            message: '删除成功'
                          });
                  this.tabeInit();
                  }else{
                    this.$message({
                                type: 'waring',
                                message: msg
                              });
                  }
            })
        })
    },
    // 重置
    resetQuery() {
      this.agentName = '';
      this.treeExpand(false);
      this.queryParams.userId = undefined;
      this.resetForm("queryParams");
      this.tabeInit();
    },
    treeExpand(flag){
        let treeList = this.agentList;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.tree.store.nodesMap[treeList[i].userId].expanded = flag;
        }
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.tabeInit();
    },
        // 取消按钮
    cancel() {
      this.open = false;
      this.filterText = '';
      this.formTreeExpand();
      this.resetForm("form");
      this.search();
    },
    formTreeExpand(){
        let treeList = this.agentList;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.agent.store.nodesMap[treeList[i].userId].expanded = false;
        }
    },
    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      this.$refs.agent.setCheckedNodes(value ? this.agentList: []);
    },
    // 所有代理商节点数据
    getAgentAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.agent.getCheckedKeys();
      return checkedKeys;
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.userIds = this.getAgentAllCheckedKeys();
          saveOrUpdateProductFreeBatch(this.form).then(res => {
            if(res.data.code == 200){
              this.$message.success("设置代理商赠送套餐成功");
              this.open = false;
              this.search();
            }else{
              this.$message.error(res.data.message);
            }
            
          });
        }
      });
    },
    editSubmit(){
        this.$refs["editForm"].validate(valid => {
        if (valid) {
          if(!!this.editForm.id){
            updateProductFree(this.editForm).then(res => {
              if(res.data.code == 200){
                this.$message.success("赠送套餐修改成功");
                this.editOpen = false;
                this.search();
              }else{
                this.$message.error(res.data.message);
              }
            });
          }else{
            let userId = this.editForm.userId;
            this.editForm.userIds = [userId];
            saveOrUpdateProductFreeBatch(this.editForm).then(res => {
              this.$message.success("赠送套餐新增成功");
              this.editOpen = false;
              this.search();
            });
          }
          
        }
      });
    },
    cancelEdit(){
      this.editOpen = false;
      this.search();
    }
  },
  mounted() {
  },
  created() {
    this.agentTree();
    this.tabeInit();
  }
};
</script>
<style scoped lang="less">
.down-tree{
    height: 300px;
    display: block;
    overflow-y: scroll;

}
@media (min-width: 1156px) {
  .agent-tree{
    height: 700px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;

  }
}
@media screen and (min-width: 768px) and (max-width: 1156px){
				
	.agent-tree{
    height: 500px;
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;

  }
}
</style>